module.exports = __webpack_public_path__ + "satsuma-horiz-logo-black.svg?4cfb77d2471b6289f8d7af0dd749afae";


//////////////////
// WEBPACK FOOTER
// ./static/satsuma-horiz-logo-black.svg
// module id = 310
// module chunks = 0